import Link from 'next/link'
import { useInView } from 'react-intersection-observer';
import styled, { css } from 'styled-components';
import SwiperCore, { Pagination } from 'swiper'
import { breakpoint } from '../layout/styles';
import Cta from '../styles/Cta'

SwiperCore.use([Pagination]);

const Testimonials = ({ testimonial }: any) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 })
  return (
    <Wrapper ref={ref} inView={inView}>
      <Testimonial>
        {testimonial.ingredients.front_left_ingredient &&
          <Ingredient1
            src={`${testimonial.ingredients.front_left_ingredient.url}?width=${440}&auto=webp&format=png`}
            srcSet={`${testimonial.ingredients.front_left_ingredient.url}?width=${440}&dpr=2&auto=webp&format=png 2x`}
            alt={testimonial.ingredients.front_left_ingredient.description || 'Ingredient'}
            aria-hidden="true"
            width={440}
            height={200} />}
        {testimonial.ingredients.front_right_ingredient &&
          <Ingredient2
            src={`${testimonial.ingredients.front_right_ingredient.url}?width=${232}&auto=webp&format=png`}
            srcSet={`${testimonial.ingredients.front_right_ingredient.url}?width=${232}&dpr=2&auto=webp&format=png 2x`}
            alt={testimonial.ingredients.front_right_ingredient.description || 'Ingredient'}
            aria-hidden="true"
            width={232}
            height={232} />}
        <h3>"{testimonial.snippet}"</h3>
        {testimonial.publication_logo &&
          <img
            src={`${testimonial.publication_logo.url}?width=${160}&auto=webp&format=png`}
            srcSet={`${testimonial.publication_logo.url}?width=${160}&dpr=2&auto=webp&format=png 2x`}
            width={160}
            height={40}
            alt={testimonial.publication_logo.description} />}
      </Testimonial>
      <Container>
        <h2>{testimonial.featured_in_title}</h2>
        <FeaturedIn>
          {testimonial.featured_in.map((item: any, index: number) =>
            <Item key={index}>
              <a href={item.link.href} target="_blank">
                {testimonial.publication_logo &&
                  <img
                    src={`${item.logo.url}?width=${280}&auto=webp&format=png`}
                    srcSet={`${item.logo.url}?width=${280}&dpr=2&auto=webp&format=png 2x`}
                    width={280}
                    height={40}
                    alt={item.logo.description} />}
              </a>
            </Item>)}
        </FeaturedIn>
        <Link href={testimonial.cta.href}>
          <Cta href="">{testimonial.cta.title}</Cta>
        </Link>
      </Container>
    </Wrapper>
  )
}

export default Testimonials

const Wrapper = styled.section<any>`
  position: relative;
  transition: all 1s ease;
  transform: translateY(10%);
  opacity: 0;
  color: var(--text);
  padding: 2rem 0;
  ${props => props.inView && css`
    transform: translateY(0);
    opacity: 1;
  `}
  @media ${breakpoint.desktop} {
    padding: 6rem 0;
  }
`

const Testimonial = styled.section<any>`
  max-width: 1120px;
  position: relative;
  margin: 0 auto;
  text-align: center;
  padding: 2rem;
  @media ${breakpoint.desktop} {
    padding: 0 0 7rem;
  }
  background: var(--gradient);
  h3 {
    font-size: 32px;
    font-style: italic;
    font-weight: 600;
    line-height: 46px;
    text-align: center;
    margin: 0 0 24px 0;
  }
  img {
    width: auto;
    height: auto;
    max-width: 160px;
    max-height: 32px;
    min-width: 80px;
    min-height: 18px;
    @media ${breakpoint.desktop} {
      max-width: 280px;
      max-height: 72px;
      min-width: 180px;
      min-height: 32px;
    }
  }
`

export const Container = styled.div`
  text-align: center;
  h2 {
    margin: 1rem 0;
    font-size: 16px;
    text-transform: uppercase;
    @media ${breakpoint.desktop} {
      margin: 3rem 0 4rem;
      font-size: 36px;
      text-transform: none;
      opacity: 0.6;
    }
    font-weight: 700;
    line-height: 46px;
  }
  ${Cta} {
    opacity: 0.6;
  }
`

const Ingredient = styled.img`
  object-fit: contain;
  object-position: center center;
  position: absolute;
  pointer-events: none;
`

const Ingredient1 = styled(Ingredient)`
  bottom: -36px;
  left: -150px;
`

const Ingredient2 = styled(Ingredient)`
  bottom: -72px;
  left: inherit;
  right: -120px;
`

const FeaturedIn = styled.div<any>`
  display: flex;
  justify-content: center;
  max-width: 1120px;
  margin: 3rem auto;
  flex-direction: column;
  @media ${breakpoint.desktop} {
    flex-direction: row;
  }
`

const Item = styled.div<any>`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  border-right: 1px var(--border) solid;
  @media ${breakpoint.desktop} {
    padding: 0 100px;
  }

  &:last-child {
      border-right: 0;
  }

  a {
    display: block;
    transition: all 350ms ease;
    @media (hover: hover) {
      &:hover {
        transform: translateY(-10px);
      }
    }
  }

  img {
    width: auto;
    height: auto;
    max-width: 180px;
    max-height: 48px;
    min-width: 120px;
    min-height: 42px;
    @media ${breakpoint.desktop} {
      max-width: 280px;
      max-height: 72px;
      min-width: 180px;
      min-height: 32px;
    }
  }
`